import React, { useEffect, useState } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { TranslationKeys } from '../../../enums';

const gameMaxOdd = 100;

export const PrizeTicker = () => {
  const t = useTranslation();
  const [slide, setSlide] = useState(true);
  const [isClose, setIsClose] = useState(false);
  const [timeOutId, setTimeOutId] = useState(null);
  const [timeOutId1, setTimeOutId1] = useState(null);

  const handleAnimationEnd = () => {
    setSlide(false);

    setTimeOutId(
      setTimeout(() => {
        setIsClose(true);
        setTimeOutId(null);
      }, 2000)
    );

    setTimeOutId1(
      setTimeout(() => {
        setSlide(true);
        setIsClose(false);
        setTimeOutId1(null);
      }, 2200)
    );
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeOutId);
      clearTimeout(timeOutId1);
    };
  }, []);

  return (
    <div className='prize-wrapper'>
      <div className='prize-holder' style={slide ? {} : { justifyContent: 'center' }}>
        <p
          className={`prize-text ${slide ? 'slide-text' : ''}`}
          onAnimationEnd={handleAnimationEnd}
        >
          {slide ? t(TranslationKeys.AdvertisingText) : ''}
        </p>
        {!slide ? <div className={`xxx ${isClose ? 'close' : ''}`}>x{gameMaxOdd}</div> : null}
      </div>
    </div>
  );
};
